import { render, staticRenderFns } from "./Allottees.vue?vue&type=template&id=4c359826&scoped=true"
import script from "./Allottees.vue?vue&type=script&lang=js"
export * from "./Allottees.vue?vue&type=script&lang=js"
import style0 from "./Allottees.vue?vue&type=style&index=0&id=4c359826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c359826",
  null
  
)

export default component.exports